import { api } from './api-client';
import type { GetUsers, UsersData } from '@/types';

export const UsersService = {
  getUsers: async ({ projectId, page }: GetUsers): Promise<UsersData> => {
    const params = new URLSearchParams();
    if (page) params.append('page', page.toString());
    const { data } = await api.get<{ data: UsersData }>(`/projects/${projectId}/users?${params}`);
    return data;
  },
};
